import { TNoteVersion } from "~/interfaces";
import { store } from "~/state/store";
import { openPropositionDialog } from "~/util/premium";

export function getNoteVersion(): TNoteVersion {
	if (Mapy.CUS.mapybox?.noteV2) {
		return "version2";
	}

	return "version1";
}

// muzu mit poznamku - flag u uzivatele nebo klikatko, musi byt poznamka povolena
export function isPremiumNoteUser() {
	/* eslint-disable */
	const mapyConf = Mapy.CUS.user?.premiumNote;
	const userState = store.getState().user.user?.premium || false;

	return mapyConf || userState;
}

export function checkNoteVersion(curVersion: TNoteVersion, minVersion: TNoteVersion) {
	// vse povolene
	if (minVersion === "version1") {
		return true;
	}

	if (minVersion === "version2") {
		return curVersion === "version2";
	}

	return false;
}

export function openPremiumOnboarding() {
	openPropositionDialog("MyMapsNotes");
}
